/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 実行日設定リクエストボディ
 * @export
 * @interface ExecutionDaySetting
 */
export interface ExecutionDaySetting {
    /**
     * 実行日タイプ
     * @type {string}
     * @memberof ExecutionDaySetting
     */
    'executionDayType': ExecutionDaySettingExecutionDayTypeEnum;
}

export const ExecutionDaySettingExecutionDayTypeEnum = {
    OnlyOnWeekdays: 'only_on_weekdays',
    Everyday: 'everyday'
} as const;

export type ExecutionDaySettingExecutionDayTypeEnum = typeof ExecutionDaySettingExecutionDayTypeEnum[keyof typeof ExecutionDaySettingExecutionDayTypeEnum];


